import { render, staticRenderFns } from "./DashbaordTraffic.vue?vue&type=template&id=342cbb14&scoped=true&"
import script from "./DashbaordTraffic.vue?vue&type=script&lang=js&"
export * from "./DashbaordTraffic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342cbb14",
  null
  
)

export default component.exports